import { DateTime } from 'luxon';

import { DASH } from '@/globals';

interface IReachAndFrequencyReportAPI {
  id: number;
  workflowexecution_id: number;
  hivestack_environment: string;
  file_location: string;
  entity_type: string;
  entity_id: number;
  organization_id: number;
  created_on_utc: string;
  modified_on_utc: string;
}

export default class ReachAndFrequencyReport {
  id: number;

  workflowExecutionId: number;

  hivestackEnvironment: string;

  fileLocation: string;

  entityType: string;

  entityId: number;

  organizationId: number;

  createdOnUTC: string;

  modifiedOnUTC: string;

  constructor(
    id = -1,
    workflowExecutionId,
    hivestackEnvironment,
    fileLocation,
    entityType,
    entityId,
    organizationId,
    createdOnUTC,
    modifiedOnUTC,
  ) {
    this.id = id;
    this.workflowExecutionId = workflowExecutionId;
    this.hivestackEnvironment = hivestackEnvironment;
    this.fileLocation = fileLocation;
    this.entityType = entityType;
    this.entityId = entityId;
    this.organizationId = organizationId;
    this.createdOnUTC = createdOnUTC;
    this.modifiedOnUTC = modifiedOnUTC;
  }

  static fromAPI(apiObject: IReachAndFrequencyReportAPI): ReachAndFrequencyReport {
    return new ReachAndFrequencyReport(
      apiObject.id,
      apiObject.workflowexecution_id,
      apiObject.hivestack_environment,
      apiObject.file_location,
      apiObject.entity_type,
      apiObject.entity_id,
      apiObject.organization_id,
      apiObject.created_on_utc,
      apiObject.modified_on_utc,
    );
  }

  toAPI() {
    return {
      id: this.id,
    };
  }

  get createdOnFormatted() {
    return this.createdOnUTC
      ? DateTime.fromISO(this.createdOnUTC, { zone: 'utc' }).toLocal().toLocaleString(DateTime.DATETIME_MED)
      : DASH;
  }

  get modifiedOnFormatted() {
    return this.modifiedOnUTC
      ? DateTime.fromISO(this.modifiedOnUTC, { zone: 'utc' }).toLocal().toLocaleString(DateTime.DATETIME_MED)
      : DASH;
  }
}
